import { TextField } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'

function TextForm({
  control,
  errors,
  dynamicField,
  label,
  required,
  min,
  max,
  disabled,
  type,
  multiline,
  rows,
  minValue,
  maxValue,
  onChange,
  onBlur
}) {
  return (
    <div>
      <Controller
        name={dynamicField}
        control={control}
        defaultValue=""
        rules={{
          required: {
            value: required,
            message: 'This field is required',
          },
          minLength: {
            value: min,
            message: `${label} must be at least ${min} characters`,
          },
          maxLength: {
            value: max,
            message: `${label} cannot exceed ${max} characters`,
          },
          min: {
            value: minValue,
            message: `It cannot be less than ${minValue}`,
          },
          max: {
            value: maxValue,
            message: `It cannot be more than  ${maxValue}`,
          },
        }}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            multiline={multiline}
            rows={rows}
            type={type}
            size="small"
            label={label}
            error={Boolean(errors?.[dynamicField])}
            helperText={errors?.[dynamicField] ? errors?.[dynamicField]?.message : ''}
            disabled={disabled}
            style={{
              color: disabled && 'black !important',
              background: disabled && 'hsl(0, 0%, 95%)',
            }}
            onChange={(e) => {
              field.onChange(e);
              onChange && onChange(e);
            }}
            onBlur={(e) => {
              field.onBlur();
              onBlur && onBlur(e);
            }}
          />
        )}
      />
    </div>
  )
}

export default TextForm